"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisclaimerContainer = exports.NextBtnContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.NextBtnContainer = styled_1.default.div `
  display: flex;
  justify-content: flex-end;
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
exports.DisclaimerContainer = styled_1.default.div `
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_light')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
`;
//# sourceMappingURL=styles.js.map